// Account/service availability is independent from a history session's resumability.
export function conversationAvailable(page) {
  return !!(page.initialized && page.caps && page.caps.enabled &&
    !page.initialBlock && !page.availabilityBlock && !page.initializing);
}

export function canEnterConversation(page) {
  return conversationAvailable(page) && !page.busy && !page.speechActive;
}
